import VehicleBlockAttribute from './VehicleBlockAttribute';

export default VehicleBlockAttribute;
export { VehicleBlockAttribute };
